/**
 * @generated SignedSource<<59b6bab26c34c41dc5633aaae15b2780>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedNullSearchRelatedItems_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useMeasurementUnit_user" | "SbSharedNullSearchRelatedItemsFollow_user">;
  readonly " $fragmentType": "SbSharedNullSearchRelatedItems_user";
};
export type SbSharedNullSearchRelatedItems_user$key = {
  readonly " $data"?: SbSharedNullSearchRelatedItems_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedNullSearchRelatedItems_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedNullSearchRelatedItems_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItemsFollow_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "de5024cff24e25e65909b4f3f15bcdb4";

export default node;
